// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bs-b";
export var colorBlue = "_bs-8";
export var colorDot = "_bs-0";
export var colorDotLarge = "_bs-2";
export var colorDotSmall = "_bs-1";
export var colorGreen = "_bs-7";
export var colorGrey = "_bs-3";
export var colorOrange = "_bs-5";
export var colorPink = "_bs-a";
export var colorPurple = "_bs-9";
export var colorRed = "_bs-4";
export var colorYellow = "_bs-6";